<input
    class="search-input"
    matInput
    type="text"
    placeholder="Search..."
    [formControl]="searchCtrl"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()"
    style="width:100%; border:1px solid #ccc; outline:none; padding:8px; border-radius:4px;margin:5px">
